export default "__VITE_ASSET__CKnjpWQF__"